import { Col, Row } from 'reactstrap';
import { LabeledField, AddressDisplay } from "components/common/standardComponents";
import dayjs from "dayjs";
import { genderCodeToDisplayName } from '../../../lib/standardLibrary';
import { PhoneNumber } from '../../../components/common/phoneNumber';
import { useAppSelector } from '@/store';
import '../css/patientDetails.css';

export default function PatientDetails({ patient, config }: { patient: any, config: any }) {

    return (
        <div>
            <div className="col-lg-12" style={{ marginTop: '10px' }}>
                <Row>
                    {config.memberId.isVisible && 
                        <Col lg="2">
                            <PatientMemberId patient={patient} config={config} />
                        </Col>
                    }
                    {config.groupNumber.isVisible &&
                        <Col lg="2">
                            <PatientGroupNumber patient={patient} config={config} />
                        </Col>
                    }
                    <Col lg="2">
                        <PatientDateOfBirth patient={patient} />
                    </Col>
                    <Col lg="2">
                        <PatientGender patient={patient} config={config} />
                    </Col>
                    <Col lg="2">
                        <PatientHomePhone patient={patient} />
                    </Col>
                    <Col lg="2">
                        <PatientMobilePhone patient={patient} />
                    </Col>
                </Row>
                <Row>
                    <Col xxl="4" xl="6">
                        <PatientAddress patient={patient} />
                    </Col>
                    <Col lg="4">
                        <PatientEmail patient={patient} />
                    </Col>
                    {(config.enablePatientSearchWithPool && config.patientPool.isVisible) &&
                        <Col lg="4">
                            <PatientPool patient={patient} config={config} />
                        </Col> 
                    }
                </Row>
                {config.notes.isVisible &&
                    <Row>
                        <Col lg="auto">
                            <PatientNotes patient={patient} config={config} />
                        </Col>
                    </Row>
                }
            </div>
        </div>
    )
}

const PatientNotes = ({ patient, config }: { patient: any, config: any }) => {
    return (
        <LabeledField
            label={config.notes.fieldLabel}
            value={patient.details.notes}
            isHidden={!config.notes.isVisible}
        />
    )
}

const PatientMemberId = ({ patient, config }: { patient: any, config: any }) => {
    return (
        <LabeledField
            label={config.memberId?.fieldLabel ?? 'Member Id'}
            value={patient.details.memberId}
            isHidden={!config.memberId.isVisible}
        />
    )
}

const PatientDateOfBirth = ({ patient }: { patient: any }) => {
    return (
        <LabeledField
            label="Date of Birth"
            value={patient.details.dateOfBirth ? dayjs(patient.details.dateOfBirth).format('MM/DD/YYYY') : '-'}
        />
    )
}

const PatientHomePhone = ({ patient }: { patient: any }) => {
    return (
        <LabeledField label="Home Phone" value={<PhoneNumber value={patient.details.homePhone} />} />
    )
}

const PatientAddress = ({ patient }: { patient: any }) => {
    return (
        <AddressDisplay label="Address" address={patient.details} />
    )
}

const PatientGroupNumber = ({ patient, config }: { patient: any, config: any }) => {
    return (
        <LabeledField
            label="Group Number"
            value={patient.details.groupNumber}
            isHidden={!config.groupNumber.isVisible}
        />
    )
}

const PatientGender = ({ patient, config }: { patient: any, config: any }) => {
    return (
        <LabeledField label={config.gender?.fieldLabel ?? 'Gender'} value={genderCodeToDisplayName(patient.details.gender)} />
    )
}

const PatientMobilePhone = ({ patient }: { patient: any }) => {
    return (
        <LabeledField label="Mobile Phone" value={<PhoneNumber value={patient.details.mobilePhone} />} />
    )
}

const PatientEmail = ({ patient }: { patient: any }) => {
    return (
        <LabeledField label="Email" value={patient.details.email} />
    )
}

const PatientPool = ({ patient, config }: { patient: any, config: any }) => {
    return (
        <LabeledField
            label={config.patientPool.fieldLabel}
            value={patient.details.patientPool.displayName}
            isHidden={!config.patientPool.isVisible}
        />
    )
}